import React, { Fragment } from "react";
import PageHead from "../Head";
import { Provider } from "react-redux";
import Store from "@/redux/store";
import Context from "@/context/Context";
import HeaderStyleTen from "@/components/Header/HeaderStyle-Ten";
import MobileMenu from "@/components/Header/MobileMenu";
import Cart from "@/components/Header/Offcanvas/Cart";
import BackToTop from "../backToTop";
import FooterThree from "@/components/Footer/Footer-Three";
import Footersection from "@/components/Category/Footersection";
import ContactCards from "@/components/Category/ContactCards";
import { getBranches } from "@/lib/api/branches";

const ContactUs = ({ branches }) => {
  return (
    <Fragment>
      <PageHead title="Testimonials-Immigration Guru's-Contact-Us"
        description="Contact The Immigration Gurus — offices in Karnal, Nawanshahr, Chandigarh, Indri, Dubai and Canada. Call us or book a free study abroad consultation." />
      <Provider store={Store}>
        <Context>
          <HeaderStyleTen headerSticky="rbt-sticky" headerType={true} />
          <MobileMenu />
          <Cart />
          <BackToTop />
          <ContactCards branches={branches} />

          <Footersection />

          <FooterThree />
        </Context>
      </Provider>
    </Fragment>
  );
};

// Rebuilt in the background every 5 minutes, so branch edits in the admin reach
// the page without a redeploy while the route stays statically served.
export async function getStaticProps() {
  const branches = await getBranches();
  return {
    props: { branches },
    revalidate: 300,
  };
}

export default ContactUs;
